import React, { useEffect, useState } from "react";

import { fetchLevelTestSummaryAPI } from "../levelTestAPI";
import { readSessionFromUrl } from "../session";
import LevelTestInvite, { formatMonthLabel } from "./LevelTestInvite";
import LevelTestReportCard from "./LevelTestReportCard";
import "./LevelTestSummary.css";

// 레벨테스트 요약 카드. 알림장 화면 맨 위에 붙어서, 이번 달 결과와 지난 응시를 보여준다.
// 학생이 "내가 뭘 봤고 몇 점인지" 를 자기 링크 안에서 바로 보게 하는 것이 목적이다.
const LevelTestSummary = () => {
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const identity = readSessionFromUrl();
    if (!identity) {
      setIsLoading(false);
      return undefined;
    }

    const { studentId, randomCode } = identity;

    let isCurrent = true;
    fetchLevelTestSummaryAPI(studentId, randomCode)
      .then((data) => {
        if (isCurrent) {
          setSummary(data);
          setIsLoading(false);
        }
      })
      .catch(() => {
        // 레벨테스트를 아직 안 쓰는 학원도 있다. 못 불러오면 카드를 그리지 않는다.
        if (isCurrent) {
          setIsLoading(false);
        }
      });

    return () => {
      isCurrent = false;
    };
  }, []);

  if (isLoading || !summary) {
    return null;
  }

  // 체험 학생은 응시 기록이 없다. 대신 예시 리포트 한 장으로 보낸다. 선생님이
  // 출제를 체험해 본 뒤 "레벨테스트는 뭐가 나오나" 까지 눌러 볼 수 있어야 한다.
  if (summary.demo_report_url) {
    return (
      <section className="level-test-summary">
        <div className="level-test-summary__header">
          <div className="level-test-summary__title">레벨테스트</div>
          <div className="level-test-summary__month">체험</div>
        </div>
        <a
          className="level-test-summary__latest"
          href={summary.demo_report_url}
          target="_blank"
          rel="noreferrer"
        >
          <div className="level-test-summary__latest-detail">
            <div className="level-test-summary__stage">성적 리포트 예시</div>
            <div className="level-test-summary__count">
              단어 · 문법 · 듣기 · 문해력 네 영역의 레벨과 복습을 볼 수 있어요.
            </div>
          </div>
          <span className="level-test-summary__report-go">리포트 보기 ›</span>
        </a>
      </section>
    );
  }

  // 이번 호를 아직 안 본 학생에게 띄우는 안내.
  //
  // **응시 기록이 아예 없는 학생에게만 이 카드를 쓴다.** 흐린 예시 성적표를 깔고
  // 응시코드와 버튼을 올린다. 아직 아무도 응시하지 않은 학원(울쌤·정탑·멘토탑)은
  // 이어 둘 기록이 없어 지금까지 화면에 아무것도 안 떴다.
  //
  // **기록이 있는 학생에게는 별도 카드를 얹지 않는다.** 자기 성적표를 그대로 두고
  // 그 안에 '이번 호 응시하기' 만 넣는다. 카드가 둘이면 어느 것이 자기 것인지
  // 헷갈리고, 이미 있는 성적표를 흐리게 덮을 이유도 없다.
  const inviteCard = summary.invite ? (
    <LevelTestInvite invite={summary.invite} />
  ) : null;

  if (!summary.linked) {
    return inviteCard;
  }

  const { latest, results } = summary;
  const journey = summary.journey || [];

  // 응시 기록이 없으면 안내 카드만 그린다. 코드도 없으면 아무것도 그리지 않는다.
  // 레벨테스트를 안 쓰는 학원 학생에게는 '아직 보지 않았어요' 같은 안내조차 없던
  // 메뉴가 생긴 것으로 보인다.
  if (!results.length) {
    return inviteCard;
  }

  const invite = summary.invite;

  return (
    <LevelTestReportCard
      latest={latest}
      results={results}
      journey={journey}
      goSlot={
        <span className="level-test-summary__go-column">
          {latest && latest.report_url && (
            <a
              className="level-test-summary__report-go"
              href={latest.report_url}
              target="_blank"
              rel="noreferrer"
            >
              리포트 보기 ›
            </a>
          )}
          {/* 이번 호를 아직 안 봤으면 성적표 안에서 바로 보내 준다. 카드를 따로
              띄우는 것보다, 지난 점수 옆에 두는 편이 왜 봐야 하는지가 분명하다. */}
          {invite && (
            <a
              className="level-test-summary__test-go"
              href={invite.test_url}
              target="_blank"
              rel="noreferrer"
            >
              {formatMonthLabel(invite.month)} 호 응시하기 ›
            </a>
          )}
        </span>
      }
    />
  );
};

export default LevelTestSummary;
